<div class="wrapper">
  <app-internal-test-details [data]="data" />
  <app-actions-section
    [disableAddMenu]="disableAddMenu"
    class="actions-section w-[455px]"
  />
</div>
